import { render, staticRenderFns } from "./SchedulesPage.vue?vue&type=template&id=2ff1d2d6&scoped=true"
import script from "./SchedulesPage.vue?vue&type=script&lang=js"
export * from "./SchedulesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1d2d6",
  null
  
)

export default component.exports